import React from 'react';
import { Box, Typography } from '@mui/material';
import loadingGif from '../assets/loadingGIDRtransparent.gif';
import { useTranslation } from 'react-i18next';

const LoadingOverlay = ({ isLoading }) => {
  const { t } = useTranslation("common");
  if (!isLoading) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        backdropFilter: 'blur(2px)',
      }}
    >
      <Box
        component="img"
        src={loadingGif}
        alt="Loading..."
        sx={{
          width: 'auto',
          height: 'auto',
          maxWidth: '200px',
          maxHeight: '200px',
          mb: 2,
        }}
      />
      <Typography
        variant="h6"
        color="text.secondary"
        sx={{
          fontWeight: 500,
          textAlign: 'center',
          maxWidth: '300px',
        }}
      >
        {t("loading")}
      </Typography>
    </Box>
  );
};

export default LoadingOverlay;
